import { get } from 'lodash';
import * as React from 'react';
import { useFormikContext } from 'formik';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import useIsMobile from '../../utils/useIsMobile';
import { useDisabled } from './providers/DisableProvider';
import useGutterBottom from './utils/useGutterBottom';

export type SelectProps = TextFieldProps & {
  name: string;
  options: {
    label: string;
    value: string | number | undefined;
    disabled?: boolean;
  }[];
  errorGutterBottom?: boolean;
};

const SelectInput = ({
  options,
  errorGutterBottom,
  name,
  ...props
}: SelectProps) => {
  const { setFieldValue, setFieldTouched, values, errors, touched } =
    useFormikContext<any>();
  const isError = !!(get(touched, name) && get(errors, name));
  const isMobile = useIsMobile();
  const { getDisabled } = useDisabled();
  const gutterSize = useGutterBottom();

  return (
    <TextField
      error={!!(get(touched, name) && get(errors, name))}
      sx={{
        paddingBottom: errorGutterBottom ? (isError ? 0 : gutterSize) : 0,
      }}
      size={isMobile ? 'small' : 'medium'}
      disabled={getDisabled?.(name)}
      {...props}
      select
      helperText={
        isError ? (get(errors, name) as string) : props.helperText || ''
      }
      value={get(values, name)}
      onChange={(event) => {
        props.onChange?.(event);
        setFieldValue(name, event.target.value);
      }}
      onBlur={(event) => {
        props.onBlur?.(event);
        setFieldTouched(name, true);
      }}
    >
      {options.map((option) => (
        <MenuItem
          key={option.value}
          value={option.value}
          disabled={option.disabled}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
};
export default SelectInput;
